export type TemplateDoctorFeeValidationInput = {
  templateDoctorFeeName?: string
  amount?: number | null
  labDoctorAmount?: number | null
}

export type TemplateDoctorFeeValidationErrors = {
  EMPTY_DF_NAME: string
  EMPTY_DF_AMOUNT: string
  EMPTY_LAB_AMOUNT: string
}

export const getTemplateDoctorFeeValidationErrors = (
  template: TemplateDoctorFeeValidationInput,
  translate: (key: string) => string
): TemplateDoctorFeeValidationErrors => ({
  EMPTY_DF_NAME: !template.templateDoctorFeeName
    ? translate('TEMPLATE_DOCTOR_FEE.MESSAGE.ERROR.EMPTY_DF_NAME')
    : '',
  EMPTY_DF_AMOUNT: !template.amount && template.amount !== 0
    ? translate('TEMPLATE_DOCTOR_FEE.MESSAGE.ERROR.EMPTY_DF_AMOUNT')
    : '',
  EMPTY_LAB_AMOUNT: !template.labDoctorAmount && template.labDoctorAmount !== 0
    ? translate('TEMPLATE_DOCTOR_FEE.MESSAGE.ERROR.EMPTY_LAB_AMOUNT')
    : '',
})

export const hasTemplateDoctorFeeValidationErrors = (
  errors: TemplateDoctorFeeValidationErrors
) => Object.values(errors).some(Boolean)
